var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSavedTicketNoCircleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon saved-ticket-no-circle-icon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.5 15a.5.5 0 110 1H.5a.5.5 0 110-1h15zM8 13a.499.499 0 01-.2-.042l.024.01a.498.498 0 01-.16-.098l.063.049a.502.502 0 01-.06-.046l-.003-.003-5.5-5a.5.5 0 11.672-.74L7.5 11.37V.5a.5.5 0 011 0v10.869l4.664-4.239a.5.5 0 01.64-.027l.066.06a.5.5 0 01-.034.707l-5.5 5a.508.508 0 01-.16.098l.024-.01A.498.498 0 018 13z"
  })));
}

export default SvgSavedTicketNoCircleIconSv;